import Vue from 'vue'
import router from './router'
import store from './store'
import i18n from '@/i18n/'
import App from '@/App.vue'
import initSensors from './utils/sensors.js'
import { hijactZoneDetailPage, shouldHijactZoneDetailPage } from '@/utils/zone.js' // 劫持详情页的路径，兼容旧版本的 zone/detail 路径
import { initTelemetry } from '@/utils/telemetry.js'

// 引入全局工具类
import Util from '@/utils/common-tools.js'

// 全局代理 Util 类，在业务代码中可以直接访问
window.$util = new Proxy(Util, {
  get(target, p) {
    return (
      target[p] ||
      function () {
        console.log(`[${p}] is undefined in <src/utils/common-tools.js>`, this)
      }.bind(Util)
    )
  }
})

// 引入暗黑模式
import '@/utils/dark.js'

// 全局公共能力
import '@/style/common.less' // 引入全局公共样式
// import '@/assets/svgs/index.js' // 注册svg组件
import '@/plugins/vant.js' // 注册vant组件库，注意按需引入

// 客户端初始化
import './utils/client-init.js'

// 引入qing的操作对象（JSB）
import * as jsbHelper from '@/utils/jsb-helper.js'
import { PUBLIC_PATH } from './constants.js'
window.$jsbHelper = jsbHelper // 也可以使用代理

Vue.config.productionTip = false

initilize()

initSensors()

function initilize() {
  // 如果是 zone/detail 路径，则将其转换为 /detail?id=xxx 的形式
  if (shouldHijactZoneDetailPage()) {
    hijactZoneDetailPage()
  } else {
    new Vue({
      router, // 支持路由
      store, // 支持vuex状态管理
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }
}

initTelemetry()
